import * as React from "react";
import * as moment from "moment";
import * as classNames from "classnames";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../_data/models/Meta";
import {ResourceType} from "../../_helpers/data";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";

interface result {
    items: any;
    meta: Meta;
    loading: boolean;
}

interface Props {
    specials: result;
    loadMore: (meta: Meta, resource: string) => void;
}

const MyProfileSpecialsComponent = ({specials, loadMore}: Props) => {
    if (specials.items.toArray().length == 0 && !specials.loading) {
        return (
            <div className="tabs-content" data-tabs-content="users">
                <div className="tabs-panel is-active">
                    No Specials
                </div>
            </div>
        )
    }
    else {
        return (
            <table>
                {!specials.loading &&
                    <thead>
                    <tr>
                        <th>Special Title</th>
                        <th>Expiration Date</th>
                        <th></th>
                    </tr>
                    </thead>
                }
                {
                    <ReduxInfiniteScroll
                        loadMore={() => loadMore(specials.meta, ResourceType.special)}
                        loadingMore={specials.loading}
                        holderType="tbody"
                        loader={
                            <tr>
                                <td><LoadingIndicatorComponent/></td>
                            </tr>
                        }
                        showLoader={true}
                        elementIsScrollable={false}
                        threshold={200}>
                        {
                            specials.items.toArray().map(special => {
                                return (
                                    <tr key={special.id}>
                                        <td>
                                            <UserRedirectContainer id={special.id} element="b"
                                                                   type={ResourceType.special}>{special.title}</UserRedirectContainer>
                                        </td>
                                        <td>{special.prettyEndDateString()}</td>
                                        <td><i className={classNames("fa fa-fw", {
                                            "fa-heart": special.likeCount > 0,
                                            "fa-heart-o": special.likeCount == 0
                                        })}/>
                                            &nbsp;{special.likeCount > 1 ? special.likeCount + ' Likes' : special.likeCount + ' Like' }
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </ReduxInfiniteScroll>
                }

            </table>
        );
    }
};

export default MyProfileSpecialsComponent;


// WEBPACK FOOTER //
// ./app/client/user/components/MyProfileSpecialsComponent.tsx